module.exports = __webpack_public_path__ + "static/media/icon_renew-disable.05a09959.svg";